import React from 'react';
import { Box, Image, Text } from '@chakra-ui/react';
import bridge from '@vkontakte/vk-bridge';

import {
  ConnectButton,
  ContainerFirstStyled,
  ContainerGroupStyled,
  ContainerLastStyled,
  ContainerSolutionStyled,
  VkPage,
} from './VKGroupConnectPage.styles';

import VkPic1Image from '../static/images/vkpic1.png';
import VkPic2Image from '../static/images/vkpic2.png';
import VkPic3Image from '../static/images/vkpic3.png';
import VkPic4Image from '../static/images/vkpic4.png';
import VkPic5Image from '../static/images/vkpic5.png';
import VkPic6Image from '../static/images/vkpic6.png';
import VkPic7Image from '../static/images/vkpic7.png';
import VkPic8Image from '../static/images/vkpic8.png';
import VkPic9Image from '../static/images/vkpic9.png';
import VkPic10Image from '../static/images/vkpic10.png';
import VkPic11Image from '../static/images/vkpic11.png';

const VK_ADVANTAGES = [
  {
    heading: 'Меньше действий - выше конверсия',
    text: 'Пользователям удобно записываться без перехода в другие системы',
    picSrc: VkPic2Image,
  },
  {
    heading: 'Быстрая обработка обращений',
    text: 'Заявки не теряются, а направляются сразу в SberCRM',
    picSrc: VkPic3Image,
  },
  {
    heading: 'Рост качества сервиса',
    text: 'Клиенты получают подтверждения и напоминания о записях',
    picSrc: VkPic4Image,
  },
  {
    heading: 'Лучшая практика в отрасли',
    text: 'Функционал, который ждут ваши клиенты и уже внедрили конкуренты',
    picSrc: VkPic5Image,
  },
];

const VK_SOLUTIONS = [
  {
    text: 'Агрегация заявок из всех каналов на одной платформе',
    picSrc: VkPic6Image,
  },
  {
    text: 'Управление штатом и расписанием работы',
    picSrc: VkPic7Image,
  },
  {
    text: 'Повышение лояльности: создание акций и бонусных систем',
    picSrc: VkPic8Image,
  },
  {
    text: 'Улучшение обслуживания: сбор отзывов, история работы с клиентом',
    picSrc: VkPic9Image,
  },
];

export const VKGroupConnectPage: React.FC = () => {
  const handleAddToVkCommunity = () => {
    bridge.send('VKWebAppAddToCommunity');
  };

  return (
    <VkPage>
      <ContainerFirstStyled>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-evenly"
        >
          <Text textStyle="vkH1" color="white">
            Принимайте заявки прямо в ВК
          </Text>
          <Text mt={4} mb={8} color="white" textStyle="vkBody">
            Добавьте форму онлайн-записи в ваше сообщество и превращайте
            подписчиков в клиентов
          </Text>
          <Box>
            <ConnectButton onClick={handleAddToVkCommunity}>
              Добавить форму записи
            </ConnectButton>
          </Box>
        </Box>
        <Box m="auto">
          <Image src={VkPic1Image} />
        </Box>
      </ContainerFirstStyled>
      <Text textStyle="vkH1" mt={12} mb={4}>
        Используйте преимущества SberCRM для записи онлайн в ВК
      </Text>
      {VK_ADVANTAGES.map(({ heading, text, picSrc }) => (
        <ContainerGroupStyled key={picSrc}>
          <Box flex="auto" alignSelf="center">
            <Text textStyle="h2" color="black">
              {heading}
            </Text>
            <Text mt={2} mb={{ base: 4, sm: 8 }} color="black">
              {text}
            </Text>
          </Box>
          <Box m="auto">
            <Image src={picSrc} />
          </Box>
        </ContainerGroupStyled>
      ))}
      <Text textStyle="vkH1" mt={12} mb={4}>
        SberCRM Сфера услуг
      </Text>
      <Box display={{ sm: 'flex' }} flexWrap="wrap" gridGap={4} my={4}>
        <ContainerSolutionStyled
          width={{ md: '284px' }}
          height={{ base: '285px', md: 'unset' }}
          alignItems="center"
        >
          <Box>
            <Text as="span" color="white" fontWeight={700} textStyle="vkBody">
              Единое решение{' '}
            </Text>
            <Text as="span" color="white" textStyle="vkBody">
              для управления любыми бизнес-процессами и выполнения ключевых
              задач компании
            </Text>
          </Box>
        </ContainerSolutionStyled>
        {VK_SOLUTIONS.map(({ text, picSrc }) => (
          <Box
            key={picSrc}
            width={{ base: '100%', sm: '284px' }}
            mt={{ base: 4, sm: 'unset' }}
          >
            <Image mb={4} src={picSrc} width={{ base: '100%', sm: 'unset' }} />
            <Text>{text}</Text>
          </Box>
        ))}
        <Box
          width={{ base: '100%', md: '284px' }}
          mt={{ base: 4, sm: 'unset' }}
        >
          <Box bgColor="#EBECF3" borderRadius="20px" mb={4}>
            <Image
              m="auto"
              src={VkPic10Image}
              width={{ base: '100%', sm: 'unset' }}
            />
          </Box>
          <Text>Отслеживание и анализ ключевых показателей бизнеса</Text>
        </Box>
      </Box>
      <ContainerLastStyled>
        <Box
          p={{ base: 0, sm: '40px 0 40px 40px' }}
          display="flex"
          flexDirection="column"
          justifyContent="space-evenly"
        >
          <Box>
            <Text textStyle="vkH1" color="white">
              Подключите форму онлайн-записи в ВК
            </Text>
            <Text
              mt={4}
              mb={{ base: 4, sm: 8 }}
              color="black"
              textStyle="vkBody"
            >
              Используйте дополнительный канал привлечения клиентов
            </Text>
          </Box>
          <Box>
            <ConnectButton onClick={handleAddToVkCommunity}>
              Подключить
            </ConnectButton>
          </Box>
        </Box>
        <Box m="auto">
          <Image src={VkPic11Image} maxH={{ sm: '323px' }} />
        </Box>
      </ContainerLastStyled>
    </VkPage>
  );
};
